import { useForm } from '@inertiajs/react';
import { useCallback, useMemo } from 'react';

export function useInertiaForm(initialData) {
  const form = useForm(initialData);
  const defaultData = useMemo(
    () => ({
      ...initialData,
    }),
    [],
  );
  const getError = useCallback(
    (field) => {
      return form.errors[field];
    },
    [form.errors],
  );
  const hasFieldError = useCallback(
    (field) => {
      return !!form.errors[field];
    },
    [form.errors],
  );
  const isFieldDirty = useCallback(
    (field) => {
      return form.data[field] !== defaultData[field];
    },
    [form.data, defaultData],
  );
  const field = useCallback(
    (name) => ({
      name,
      value: form.data[name],
      error: form.errors[name],
      onChange: (e) => {
        const target = e.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        form.setData(name, value);
      },
    }),
    [form.data, form.errors, form.setData],
  );
  return {
    data: form.data,
    isDirty: form.isDirty,
    errors: form.errors,
    hasErrors: form.hasErrors,
    processing: form.processing,
    wasSuccessful: form.wasSuccessful,
    recentlySuccessful: form.recentlySuccessful,
    setData: form.setData,
    reset: form.reset,
    clearErrors: form.clearErrors,
    post: form.post,
    patch: form.patch,
    put: form.put,
    delete: form.delete,
    cancel: form.cancel,
    getError,
    hasFieldError,
    isFieldDirty,
    field,
  };
}
